import type { OddsFormat } from '@cx-modules/types';

import type { Odd } from '../types';

import { isOddsActive, roundOdds } from './index';

/**
 * Formats odds value for display based on format preference.
 * Extracted from OddsCell to allow pre-computation in parent.
 */
export const formatOddsText = (odds: Odd | undefined, oddsFormat: OddsFormat): string | number | undefined => {
  if (typeof odds === 'undefined' || !isOddsActive(odds)) {
    return undefined;
  }

  const { decimal, fractional } = odds;

  if (fractional === 'SP' || !fractional || !decimal) {
    return 'SP';
  }

  const [numerator, denominator] = fractional.split('/');
  const oddsTrad = fractional.length > 5 ? `${numerator}/ ${denominator}` : fractional;

  if (oddsFormat === 'american') return odds.american;

  return oddsFormat === 'traditional' || oddsFormat === 'fractional' ? oddsTrad : roundOdds(decimal);
};
